import { render, staticRenderFns } from "./TeamsystemIntegratorListComponent.vue?vue&type=template&id=a5115770&scoped=true"
import script from "./TeamsystemIntegratorListComponent.vue?vue&type=script&lang=js"
export * from "./TeamsystemIntegratorListComponent.vue?vue&type=script&lang=js"
import style0 from "./TeamsystemIntegratorListComponent.vue?vue&type=style&index=0&id=a5115770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5115770",
  null
  
)

export default component.exports